export const GET_PROCESSINGTYPES = "GET_PROCESSINGTYPES";
export const ADD_PROCESSINGTYPE = "ADD_PROCESSINGTYPE";
export const EDIT_PROCESSINGTYPE = "EDIT_PROCESSINGTYPE";
export const GET_PROCESSINGTYPE = "GET_PROCESSINGTYPE";
export const RESET_PROCESSINGTYPE = "RESET_PROCESSINGTYPE";
export const ERROR_PROCESSINGTYPE = "ERROR_PROCESSINGTYPE";
export const GET_ALL_PROCESSINGTYPES = "GET_ALL_PROCESSINGTYPES";
                